module.exports = __webpack_public_path__ + "static/avatar_ani_lorak@2x-17cd21ec2c94df1e6185af3825462a67.jpg";